const Checkbox = (props) => {
  const { isChecked, defaultValue, label, setterFunction } = props;
  return (
    <div className="input-check">
      <label htmlFor={label}>{label}: </label>
      <input
        type="checkbox"
        id={label}
        name={label}
        value={defaultValue}
        checked={isChecked}
        onChange={(e) => {
          const { name, checked } = e.target;
          setterFunction((prev) => ({
            ...prev,
            [name]: checked,
          }));
        }}
      />
    </div>
  );
};

export default Checkbox;
